{
  "welcome": "Bem-vindo ao",
  "instructions": "Toque abaixo para iniciar o processo de check-in.",
  "startCheckIn": "Iniciar check-in",
  "missingWarehouseTitle": "Armazém não encontrado",
  "missingWarehouseMessage": "O link é inválido, ele deve conter o ID do armazém",
  "recaptchaAttribution": "Este site é protegido pelo reCAPTCHA e a {privacyPolicy} e os {termsOfService} do Google se aplicam.",
  "recaptchaPrivacyPolicy": "Política de Privacidade",
  "recaptchaTermsOfService": "Termos de Serviço",
  "lookupTitle": "Adicione o número de referência ou de confirmação para encontrar seu agendamento",
  "referenceNumberLabel": "Número de referência ou número de confirmação",
  "referenceNotFoundError": "O número de referência ou de confirmação não corresponde a nenhum agendamento válido.",
  "checkIn": "Fazer check-in",
  "loadTypeLabel": "Tipo de carga",
  "directionLabel": "Direção",
  "operationLabel": "Operação",
  "dockLabel": "Doca",
  "orDivider": "ou",
  "noReferenceTitle": "Não tenho um número de confirmação",
  "noReferenceDescription": "Continue sem um agendamento usando o processo de check-in padrão.",
  "checkInWithoutAppointment": "Fazer check-in sem agendamento",
  "readyToCheckInTitle": "Pronto para fazer o check-in?",
  "readyToCheckInDescription": "Toque abaixo para começar. Você vai informar seus dados na próxima tela.",
  "referenceRequiredHint": "É necessário um número de referência para fazer o check-in neste local.",
  "haveAppointment": "Tenho um agendamento",
  "direction": {
    "inbound": "Descarga",
    "outbound": "Carga",
    "inOut": "Descarga e Carga",
    "load": "Carregamento",
    "unload": "Descarregamento"
  },
  "operation": {
    "live": "Ao vivo",
    "drop": "Drop",
    "other": "Outra"
  }
}
